export default function Partners() {
	return <section id="partners">
		<h1>Partners</h1>
		<a href="//overman.dev" target="_blank" rel="noreferrer"><img src="/img/logo_overman.png" alt="" /></a>
	</section>
}